"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasureDropdown = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var sdk_model_1 = require("@gooddata/sdk-model");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var MeasureDropdownBody_1 = require("./MeasureDropdownBody");
exports.MeasureDropdown = function (_a) {
    var items = _a.items, selectedItemRef = _a.selectedItemRef, onSelect = _a.onSelect, onDropDownItemMouseOver = _a.onDropDownItemMouseOver, onDropDownItemMouseOut = _a.onDropDownItemMouseOut, enableRenamingMeasureToMetric = _a.enableRenamingMeasureToMetric;
    var _b = react_1.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var onButtonClick = function () {
        setIsOpen(!isOpen);
    };
    var onItemSelect = function (ref) {
        onSelect(ref);
        setIsOpen(false);
        onDropDownItemMouseOut && onDropDownItemMouseOut();
    };
    var buttonClassNames = classnames_1.default("gd-button-secondary", "gd-button-small", "button-dropdown", "gd-icon-right", {
        "gd-icon-navigateup": isOpen,
        "gd-icon-navigatedown": !isOpen,
    }, "gd-rf-measure-dropdown-button", "s-rf-measure-dropdown-button");
    var selectedItem = items.find(function (item) { return sdk_model_1.areObjRefsEqual(item.ref, selectedItemRef); });
    var title = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.title;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(sdk_ui_kit_1.Button, { className: buttonClassNames, value: title, onClick: onButtonClick, iconLeft: enableRenamingMeasureToMetric ? "gd-icon-metric" : "gd-icon-measure" }),
        isOpen && (react_1.default.createElement(MeasureDropdownBody_1.MeasureDropdownBody, { items: items, selectedItemRef: selectedItemRef, onSelect: onItemSelect, onClose: function () { return setIsOpen(false); }, onDropDownItemMouseOver: onDropDownItemMouseOver, onDropDownItemMouseOut: onDropDownItemMouseOut, enableRenamingMeasureToMetric: enableRenamingMeasureToMetric }))));
};
//# sourceMappingURL=MeasureDropdown.js.map